<template>
  <div>
    <div class="contentt" id="contentt">
      <PositionGuid :posGuids="posGuids"></PositionGuid>
      <div class="lists gWidth bg-white padding">
        <div>
          <LeftNav
            :leftlists="leftlists"
            :currentIndex="currentIndex"
            @rightlist2="rightlist2"
          ></LeftNav>
          <!-- 放这里 -->
        </div>

        <div class="news_r padding-bottom">
          <div class="conts" v-if="rightlists.title">
            <span class="right_tit">{{ rightlists.title }}</span>
            <p class="text-center padding-bottom" style="margin-top: 23px">
              发布时间：{{ rightlists.created_at }}
            </p>
            <div
              class="nr padding-top padding-left padding-right right_conts_p"
              v-html="rightlists.content"
            ></div>
          </div>
          <div class="conts no-conts" v-else>
            <p class="text-center">暂无数据</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { leftlist, rightlist } from "@/api/gxq";
import LeftNav from "../../components/LeftNav/LeftNav";
import PositionGuid from "../../components/PositionGuid/PositionGuid";
export default {
  name: "Gaikuang",
  components: {
    LeftNav,
    PositionGuid,
  },
  data() {
    return {
      articleTitle: '保定国家高新技术产业开发区', // 初始标题
      contentSource: '保定国家高新技术产业开发区', // 初始内容来源
      posGuids: [
        {
          title: "高区概括",
          link: "",
        },
      ],
      leftlists: [],
      rightlists: [],
      currentPage: 1,
      currentIndex: 0,
      isLoading: false,
      id: 18,
    };
  },
  mounted() {
    this.initById(this.$route.params.id);
    this.rightlist2("", "");
    this.currentIndex = 0;
  },
  methods: {
    initById(id) {
      if (id == 18) {
        this.id = 18;
        this.leftlist2();
      } else {
        this.id = id;
        this.leftlists = [
          {
            name: "联系我们",
            id: "41",
          },
          {
            name: "组织机构",
            id: "21",
          },
        ];
      }
    },
    // 清除具有指定名称的现有 meta 标签
      clearExistingMetaTags(name) {
        const existingTags = document.querySelectorAll(`meta[name="${name}"]`);
        existingTags.forEach(tag => tag.parentNode.removeChild(tag));
      },

 
      setArticleTitleMeta() {

      const articleTitleMeta = document.createElement('meta');
      articleTitleMeta.name = 'ArticleTitle';
      articleTitleMeta.content = this.articleTitle;

      const contentSourceMeta = document.createElement('meta');
      contentSourceMeta.name = 'ContentSource';
      contentSourceMeta.content = this.contentSource;

      const firstChild = document.head.firstChild;
      if (firstChild) {
        document.head.insertBefore(articleTitleMeta, firstChild);
        document.head.insertBefore(contentSourceMeta, firstChild);
      } else {
        document.head.appendChild(articleTitleMeta);
        document.head.appendChild(contentSourceMeta);
      }

    },

    async leftlist2() {
      // console.log("测试数据-----", data2.id);
      var data3 = await leftlist({
        id: this.id,
      });
      this.leftlists = data3.data[0].child;
    },
    async rightlist2({ passId, index }) {
      // console.log("--------------------passid", passId);
      // console.log("--------------------index", index);
      this.currentIndex = index;
      const { data } = await rightlist({
        id: passId ? passId : this.id,
        page: this.currentPage - 1,
      });
      this.rightlists = data;
      this.articleTitle = data.title || '';
      this.clearExistingMetaTags('ArticleTitle');
      this.clearExistingMetaTags('ContentSource');
      this.setArticleTitleMeta();
      
      // 添加空值检查，防止 content 为 undefined 时报错
      if (this.rightlists.content) {
        const regex = new RegExp("font-family: 宋体", "g");
        const regex2 = new RegExp("line-height: 21px", "g");
        const regex3 = new RegExp(
          "font-family: Arial, Verdana, sans-serif;",
          "g"
        );
        const regex4 = /font-size\s*:\s*\d+px/g;
        this.rightlists.content = this.rightlists.content.replace(
          regex,
          "font-family: 微软雅黑"
        );
        this.rightlists.content = this.rightlists.content.replace(
          regex2,
          "line-height: 40px"
        );
        this.rightlists.content = this.rightlists.content.replace(
          regex3,
          "font-family: 微软雅黑"
        );
        this.rightlists.content = this.rightlists.content.replace(
          regex4,
          "font-size: 15px"
        );
      }
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.initById(to.params.id);
    this.rightlist2("", "");
    this.currentIndex = 0;
    next();
  },
  // beforeRouteEnter(to, from, next) {
  //   next((vm) => {
  //     console.log("beforeRouteEnter------------------");
  //     console.log(vm.$router.getRoutes());
  //   });
  // },
};
</script>
<style src="../../../vab/styles/gaikuang/gaikuang_big.css" scoped></style>
<style src="../../../vab/styles/gaikuang/gaikuang_mid.css" scoped></style>
<style src="../../../vab/styles/gaikuang/gaikuang_small.css" scoped></style>
<style scoped>
.border-bottom {
  border-bottom: 4px solid var(--primary-color);
  color: var(--text-primary);
  font-size: 12px;
}
.nr {
  color: var(--text-primary);
  font-size: 15px;
  line-height: 2;
  text-align: justify;
}
.nr img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 20px auto;
  border-radius: var(--radius-sm);
}
.nr p {
  margin-bottom: 16px;
  text-indent: 2em;
}
.nav li:nth-child(2) {
  background-color: var(--primary-dark);
}
.right_conts span {
  line-height: 34px;
}
.mores_span span:nth-child(2) {
  display: block;
}
.no-conts {
  border-bottom: 1px dotted var(--text-muted);
  height: 50px;
  line-height: 50px;
}
.conts {
  background: #fff;
  border-radius: var(--radius-md);
  padding: 0 30px 30px 30px;
}
.right_tit {
  font-size: 24px;
  color: var(--text-primary);
  text-align: center;
  padding: 30px 0 20px 0;
  font-weight: bold;
  line-height: 1.5;
}
.text-center.padding-bottom {
  color: var(--text-muted);
  font-size: 14px;
  padding-bottom: 20px;
  border-bottom: 1px dashed var(--border-color);
}
.right_conts_p {
  padding-top: 30px !important;
}
</style>
